export default __webpack_public_path__ + "static/media/img.b79c4ff1.png";